import { isAxiosError } from 'axios';
import axiosInstance from '../../utility/axiosInstance';

// types and state
import {
  setIndustries,
  createIndusry,
  updateIndusry,
  setLoading,
  setUpdate
} from '@/store/slices/industry';

// notification
import { openNotification } from '@/components/alerts/notify';
import { AppDispatch } from '@/store';

export const get_industries = async (dispatch: AppDispatch) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get('/get-industries');

    dispatch(setIndustries(response.data));
  } catch (err) {
    if (isAxiosError(err)) dispatch(setIndustries([]));
  }
  dispatch(setLoading());
};

type ICreateData = { name: string };
export const create_industry = async (
  dispatch: AppDispatch,
  data: ICreateData
) => {
  dispatch(setUpdate());
  try {
    const response = await axiosInstance.post('/create-industry', data);

    openNotification({ status: 'success', message: response.data?.message });
    dispatch(createIndusry(response.data?.data));
  } catch (err) {
    if (isAxiosError(err)) {
    }
  }
  dispatch(setUpdate());
};

type IUpdateData = { name: string; id: string };
export const update_industry = async (
  dispatch: AppDispatch,
  data: IUpdateData
) => {
  dispatch(setUpdate());
  try {
    const response = await axiosInstance.patch('/update-industry', data);

    openNotification({ status: 'success', message: response.data?.message });
    dispatch(updateIndusry(response.data?.data));
  } catch (err) {
    if (isAxiosError(err)) {
      openNotification({
        status: 'success',
        message: err?.response?.data?.message
      });
    }
  }
  dispatch(setUpdate());
};
